import qs from 'querystring';

import genericConfig from '../../../config/nb';
import { mergeDeep } from '../../../util';

import header from './header';
import { getCurrentUrl } from '../../../util/uri';
import { actions as subscriptionActions } from '../../../redux/subscription';
import { AUTH_SOURCE_TYPE_SPID } from '../../../redux/constants';

const PUBLICATION_NAME = 'sno';
const { basicConfig } = genericConfig;

const currentUrl = getCurrentUrl(window.location);

export default mergeDeep(
    {},
    basicConfig,
    {
        name: PUBLICATION_NAME,
        theme: PUBLICATION_NAME,
        header,
        myPage: {
            initializationConfig: {
                redirectUri: currentUrl,
                actions: [
                    {
                        action: subscriptionActions.fetchSubscriptions,
                        params: {
                            endpoint: `${CONFIG.myPage.apiHost}/subscriptions?${qs.stringify({
                                filters: 'active',
                            })}`,
                        },
                    },
                ],
                allowedAuthSources: [AUTH_SOURCE_TYPE_SPID],
            },
        },
        footer: {
            subscriptionTermsUrl: CONFIG.subscriptionTerms,
        },
    }
);
